import moment from "moment/moment";
import { CalendarIcon } from "./CalendarIcon";

export const DateInfo = () => {
  const hoyEs = moment().format("LL");

  return (
    <div className="Aling-date-icons">
      <CalendarIcon className="calendar-icon" color="var(--color-primary)" />
      <span className="today"> {hoyEs} </span>
    </div>
  );
};
